import { render, staticRenderFns } from "./UptimeKumaStatusPage.vue?vue&type=template&id=7c18b871&scoped=true"
import script from "./UptimeKumaStatusPage.vue?vue&type=script&lang=js"
export * from "./UptimeKumaStatusPage.vue?vue&type=script&lang=js"
import style0 from "./UptimeKumaStatusPage.vue?vue&type=style&index=0&id=7c18b871&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c18b871",
  null
  
)

export default component.exports